import React from "react";
import { Card, Button, Row, Col } from "antd";
import "../styles/MappingComplete.module.scss";
import { Icon } from "Components";
import { TenantMapping } from "../Mapping";
import { useTranslation } from "react-i18next";

interface MappingCompleteProps {
  tenantInfo: TenantMapping;
  mappingCount?: number;
  onBackToHome: () => void;
}

export const MappingComplete: React.FC<MappingCompleteProps> = ({
  tenantInfo,
  mappingCount,
  onBackToHome,
}) => {
  const { t } = useTranslation();

  return (
    <div className="mappingCompleteWrapper">
      <Card bordered={false} className="mappingCompleteCard">

        {/* Header */}
        <div className="mappingCompleteHeader">
          <div className="mappingIconWrapper">
            <Icon type="mappingComplete" />
          </div>
          <h2 className="mappingCompleteTitle">{t("mapping.createMapping.success.title")}</h2>
          <p className="mappingCompleteSubtitle">
            {t("mapping.createMapping.success.sub")}
          </p>
        </div>

        {/* Content */}
        <div className="mappingCompleteContent">
          <Row justify="space-between" className="mappingRow">
            <Col className="mappingLabel">{t("mapping.createMapping.success.details.client")}</Col>
            <Col className="mappingValue">{tenantInfo.name}</Col>
          </Row>
          <Row justify="space-between" className="mappingRow">
            <Col className="mappingLabel">{t("mapping.createMapping.success.details.mapped")}</Col>
            <Col className="mappingValue">{mappingCount}</Col>
          </Row>
          <Row justify="space-between" className="mappingRow">
            <Col className="mappingLabel">{t("mapping.createMapping.success.details.status")}</Col>
            <Col className="mappingStatus">{t("mapping.createMapping.success.details.active")}</Col>
          </Row>
        </div>

        {/* Description */}
        <p className="mappingCompleteDescription">
          {t("mapping.createMapping.success.desc")}
        </p>

        {/* Button */}
        <div className="mappingCompleteButtonWrapper">
          <Button
            className="mappingCompleteButton"
            type="primary"
            onClick={onBackToHome}
          >
            {t("mapping.table.backToMapSettings")}
          </Button>
        </div>
      </Card>
    </div>
  );
};
